<!-- Layout -->
<sdc-dialog
  [showCloseButton]="false"
  overlayPaneWidth="704px"
  overlayPaneMaxWidth="calc(100vw - 2rem)" />
<app-layout></app-layout>
@if (isHttpLoading()) {
  <sdc-loader />
}
